import { render, staticRenderFns } from "./login-pic.vue?vue&type=template&id=7564b8f5&scoped=true"
import script from "./login-pic.vue?vue&type=script&lang=js"
export * from "./login-pic.vue?vue&type=script&lang=js"
import style0 from "./login-pic.vue?vue&type=style&index=0&id=7564b8f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7564b8f5",
  null
  
)

export default component.exports